import type { MouseEvent } from 'react';
import { ListItem, ListItemButton, ListItemText, Typography } from '@all-manager/design-system-v2';
import type { PendingQuoteRow as PendingQuoteRowData } from '../../utils/pendingQuoteRow';

type Props = {
  row: PendingQuoteRowData;
  href?: string;
  onClick: (event: MouseEvent<HTMLElement>) => void;
};

export default function PendingQuoteRow(props: Props) {
  return (
    <ListItem disablePadding>
      <ListItemButton disableGutters href={props.href} onClick={props.onClick}>
        <ListItemText primary={props.row.providerName} secondary={props.row.subtitle} />
        {props.row.formattedAmount ? (
          <Typography variant="body1Emphasis" noWrap>
            {props.row.formattedAmount}
          </Typography>
        ) : null}
      </ListItemButton>
    </ListItem>
  );
}
